import script from "./AtividadesCentralDoCoordenador.vue?vue&type=script&setup=true&lang=js"
export * from "./AtividadesCentralDoCoordenador.vue?vue&type=script&setup=true&lang=js"

import "./AtividadesCentralDoCoordenador.vue?vue&type=style&index=0&id=08eb9de8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08eb9de8"]])

export default __exports__